import { obterDispositivo } from './obterDispositivo';
/**
 * Insere um novo track de evento.
 * @param {string} name - Nome do evento.
 * @param {object} data - Informa��o do evento.
 */
export function addTrack(name, data = {}) {
    if (!window.mixpanel) {
        return;
    }
    if (data == null || data == undefined) { data = {}; }

    const hotSiteEmpresaID = document.getElementById("hotSiteEmpresaID");
    const hotSiteUrl = document.getElementById('hotSiteUrl');
    if (hotSiteEmpresaID != undefined && hotSiteUrl != undefined)
    {
        data.empresaID = hotSiteEmpresaID.value;
        data.hotsite = hotSiteUrl.value;
    }
    else {
        data.hotsite = 'empregare';
    }
    data.dispositivo = obterDispositivo();

    mixpanel.track(name, data);
}